import React from 'react'
import { Text, Box } from 'grommet'
import { isSameDay, isSameUser, getUserColor } from './utils'

const MessageText = ({
  position = 'left',
  currentMessage = { text: '' },
  previousMessage,
  messageTextContainerStyle = {},
  textStyle = {},
  linkStyle = {},
  usernameStyle = {},
  textMessageProps = {},
  renderUsername,
  renderParsedMessageText,
  ...props
}) => {
  // Memoize the props object for renderParsedMessageText
  const parsedMessageTextProps = React.useMemo(() => {
    return {
      position,
      currentMessage,
      previousMessage,
      messageTextContainerStyle,
      textStyle,
      linkStyle,
      usernameStyle,
      textMessageProps,
      renderUsername,
      renderParsedMessageText,
      ...props
    }
  }, [
    position,
    currentMessage,
    previousMessage,
    messageTextContainerStyle,
    textStyle,
    linkStyle,
    usernameStyle,
    textMessageProps,
    renderUsername,
    renderParsedMessageText,
    ...Object.values(props)
  ])

  const renderUsernameElement = () => {
    if (renderUsername) {
      const usernameProps = {
        position,
        currentMessage,
        previousMessage,
        messageTextContainerStyle,
        textStyle,
        linkStyle,
        usernameStyle,
        textMessageProps,
        renderUsername,
        renderParsedMessageText,
        ...props
      }
      return renderUsername(usernameProps)
    }
    return (
      <Text
        style={{
          color: getUserColor(currentMessage.user.name),
          marginLeft: 5,
          marginRight: 5,
          marginTop: 5,
          backgroundColor: 'transparent',
          fontSize: 16,
          fontWeight: 'bold'
        }}>
        {currentMessage.user.name}
      </Text>
    )
  }
  return (
    <Box>
      {(!isSameUser(currentMessage, previousMessage) ||
        !isSameDay(currentMessage, previousMessage)) &&
      renderUsername !== null &&
      position === 'left'
        ? renderUsernameElement()
        : null}
      {renderParsedMessageText(parsedMessageTextProps)}
    </Box>
  )
}

export default MessageText
